<template>
  <div
    id="userProfile"
    class="user-profile_container"
  >
    <template v-if="profile">
      <md-icon
        id="userProfileIcon"
        class="user-profile-icon"
      >
        person_outline
      </md-icon>
      <span
        class="user-profile_container__text"
      >
        {{ profile.name || profile.laboratoryName }}
        <md-tooltip
          md-delay="400"
          md-direction="bottom"
          width="auto"
        >
          {{ profile.name || profile.laboratoryName }}
        </md-tooltip>
      </span>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['profile'])
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  /* COMPONENT: commom/UserProfile.vue */
  .user-profile_container {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.2px;
    color: #808080;
    display: flex;
    align-items: center;
    justify-content: center;

    &__text {
      @include truncate;
      @include browser-ie-11 {
        max-width: calc(100% - 48px);
      }
    }
  }
</style>
